import React, { Component } from 'react';
import faqimg07 from '../../img/offer/faqimg07.png';
import easyday from '../../img/offer/easyday.png';
import paytm from '../../img/offer/paytm.png';
import Visa from '../../img/offer/Visa.png';

export default class OkjiiofferCard extends Component {
  render() {
    return (
      <div className="container">

<div className="flex-container wrap offer-card">
<div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={paytm} alt="logo" /></h5>
      <h3 className="card-title paytm"><strong>Using Paytm &amp; Get <span className="text-paytm">Upto ₹300</span></strong></h3>
      <button className="btn btn-paytm"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIPAYTM</h1>
    <a className="btn-learn-more"  href="/">Learn More</a>     
  </div>
  <div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={easyday} alt="logo" /></h5>
      <h3 className="card-title easyday"><strong>Buying From Easyday <span className="text-easyday">&amp; Get Upto</span> <span className="text-easyday-price">₹300</span></strong></h3>
      <button className="btn btn-easyday"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIFIRST</h1>
    <a className="btn-learn-more"  href="/">Learn More</a>     

  </div>
  <div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={Visa} alt="logo" /></h5>
      <h3 className="card-title visa"><strong>Using Visa Card &amp; <br /><span className="text-viza">Get Upto ₹300</span> <br/><span className="text-visa-price">Cashback</span></strong></h3>
      <button className="btn btn-visa"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIFIRST</h1>
    <a className="btn-learn-more"  href="/">Learn More</a>     
  </div>
  <div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={easyday} alt="logo" /></h5>
      <h3 className="card-title easyday"><strong>Buying From Easyday <span className="text-easyday">&amp; Get Upto</span> <span className="text-easyday-price">₹300</span></strong></h3>
      <button className="btn btn-easyday"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIFIRST</h1>
    <a className="btn-learn-more"  href="/">Learn More</a>     
  </div>
  <div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={paytm} alt="logo" /></h5>
      <h3 className="card-title paytm"><strong>Using Paytm &amp; Get <span className="text-paytm">Upto ₹300</span></strong></h3>
      <button className="btn btn-paytm"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIPAYTM</h1>
    <a className="btn-learn-more"  href="/">Learn More</a>     
  </div>
  <div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={easyday} alt="logo" /></h5>
      <h3 className="card-title easyday"><strong>Buying From Easyday <span className="text-easyday">&amp; Get Upto</span> <span className="text-easyday-price">₹300</span></strong></h3>
      <button className="btn btn-easyday"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIFIRST</h1>
    <a className="btn-learn-more" href="/">Learn More</a>     

  </div>
  <div className="text-center flex-item">
     <div className="card-content">
      <h5 className="img-flex"><img className="img-item" src={faqimg07} alt="logo" /> <img className="img-item" src={Visa} alt="logo" /></h5>
      <h3 className="card-title visa"><strong>Using Visa Card &amp; <br /><span className="text-viza">Get Upto ₹300</span> <br /><span className="text-visa-price">Cashback</span></strong></h3>
      <button className="btn btn-visa"> Code: OKKJIPAYTM</button>
    </div>
    <h1>OKKJIFIRST</h1>
    <a className="btn-learn-more"  href="/">Learn More</a>     

  </div>
</div>
  </div>
    )
  }
}
